export default __webpack_public_path__ + "static/media/butterfly_collage.d17dba80.jpg";